mutation RenewTokenMutation($input: RenewTokenInput!) {
    renewToken(input: $input) {
        authentificationToken
    }
}
